import { createContext, useContext, useState } from 'react';
import api from '@/lib/api';

/**
 * EntityPreviewContext — UX vrstva B.
 * Globální preview modal pro Order a Intake. Otevírá se z RefLink kdekoli v aplikaci.
 */
const Ctx = createContext(null);

export function EntityPreviewProvider({ children }) {
  const [preview, setPreview] = useState(null); // { type: 'order'|'intake', data: {...} }
  const [loading, setLoading] = useState(false);

  const openOrder = async (idOrNumber) => {
    if (!idOrNumber) return;
    setLoading(true);
    try {
      const res = await api.get('/orders');
      const o = (res.data || []).find(
        x => x.id === idOrNumber || x.orderNumber === idOrNumber
      );
      if (o) setPreview({ type: 'order', data: o });
    } catch {
      // silent — RefLink je nice-to-have, neblokujeme UI
    } finally {
      setLoading(false);
    }
  };

  const openIntake = async (idOrProtocol) => {
    if (!idOrProtocol) return;
    setLoading(true);
    try {
      const res = await api.get('/intakes');
      const i = (res.data || []).find(
        x => x.id === idOrProtocol || x.intakeProtocolNumber === idOrProtocol
      );
      if (i) setPreview({ type: 'intake', data: i });
    } catch {
      // silent
    } finally {
      setLoading(false);
    }
  };

  const close = () => setPreview(null);

  return (
    <Ctx.Provider value={{ openOrder, openIntake, preview, loading, close }}>
      {children}
    </Ctx.Provider>
  );
}

export const useEntityPreview = () => {
  const ctx = useContext(Ctx);
  // Fallback no-op pokud někdo použije RefLink mimo provider — neshodí to UI.
  return ctx || { openOrder: () => {}, openIntake: () => {}, preview: null, close: () => {} };
};
